import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	border-bottom: 0.08em solid ${vars.colorBorder};
	padding: 0 0 2em 0;
	.button-edit {
		position: absolute;
		right: 2em;
		top: 2em;
	}
	.button-edit--mobile {
		display: none;
	}
	.cols {
		display: flex;
	}

	.left-col {
		width: 20%;
		min-width: 20%;
		max-width: 20%;
		margin-right:2em;
		.logo-container {
			min-width: 8em;
			min-height: 8em;
			height: 8em;
			width: 8em;

			.logo {
				border-radius: 100%;
				width: 100%;
				height: 100%;
				object-fit: scale-down;
				object-position: center;
				background-color: transparent;
				border: 0.07em solid ${vars.colorBorder};
			}
		}
	}

	.right-col {
		width: 80%;
		min-width: 80%;
		max-width: 80%;
		display: flex;
		flex-flow: column wrap;

		.company-name {
			font-weight: 600;
			margin-bottom:1em;
		}

		.company-details {
			max-width: 70%;
			display: flex;
			flex-flow: column nowrap;
			align-items: flex-start;
			> div {
				&:not(:last-child) {
					margin-bottom: 1.2em;
				}
			}
			.company-info {
				width: 100%;
				display: flex;
				flex-flow: row nowrap;
				place-content: center flex-start;

				.info {
					display: flex;
					flex-flow: row nowrap;
					align-items: center;
					font-weight: 600;
					font-size: 0.9em;
					text-transform: capitalize;
					&:not(:last-child) {
						margin-right: 2.2em;
					}
					.info-icon {
						width: 1.2em;
						height: 1.2em;
						margin-right: .6em;
					}
				}
			}

			.company-description {
				min-height: max-content;
				margin-bottom: 0.5em;
				overflow: hidden;
				text-align: justify;
			}

			.company-socials {
				display: flex;
			}
		}
	}
.company-socials__link {
	&:not(:last-child) {
		margin-right: 1em;
	}
}
	@media all and (max-width: ${vars.tabletL}) {
		.button-edit--desktop {
			display: none;
		}
		.button-edit--mobile {
			display: block;
			font-weight: 700;
		}
		.cols {
			flex-flow: column wrap;
			gap:0;

			.left-col {
				height: 8em;
				margin: 0;
				padding: 0;

				.logo-container {
					transform: translateY(-50%);
				}
			}

			.right-col {
				width: 100%;
				max-width: 100%;
				min-width: 100%;
				height: max-content;
				font-size: 1.2em;

				.company-name {
					font-size: 1.3em;
				}

				.company-details {
					max-width: 100%;

					.company-info {
						flex-flow: column wrap;
						place-content: flex-start center;
						.info {
							&:not(:last-child) {
							margin-bottom: 1em;
							margin-right: 0;
						}
						}
					}
				}
			}
		}
	}

`;
